module.exports = __webpack_public_path__ + "media/images/email/instagram-76a811cf19e7f27815462fd19ef68343.svg";